import request from '../utils/request'

// 订阅
export function postSubscribeSubmit(data) {
  return request({
    url: 'subscribe/submit',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js